import { render, staticRenderFns } from "./PrepaidMethod.vue?vue&type=template&id=4f782081&"
import script from "./PrepaidMethod.vue?vue&type=script&lang=ts&"
export * from "./PrepaidMethod.vue?vue&type=script&lang=ts&"
import style0 from "./PrepaidMethod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports